export const Endpoint = () => `/api/v3/celery/tasktypeslist`;
export const QueryKey = () => ['v3', 'admin', 'celery', 'taskTypes'] as const;
export type Payload = never;
export type Response = string[];
